import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
const PAYKIT_ICON = 'https://cdn.magicpatterns.com/uploads/i6gyUzpJZSJ7VugVhRGhrk/paykit-icon.png';
const PAYKIT_LOGO = 'https://cdn.magicpatterns.com/uploads/ahteCuqfRZXgb5T7bgbdNe/paykit-logo.png';
export function SetupLayout() {
  return <div className="min-h-screen flex flex-col bg-background" data-id="element-301">
      <header className="h-16 border-b border-border bg-background flex items-center px-6 justify-between sticky top-0 z-50" data-id="element-302">
        <div className="flex items-center gap-6" data-id="element-303">
          <Link to="/" className="flex items-center gap-2" data-id="element-304">
            <img src={PAYKIT_ICON} alt="PayKit" className="w-8 h-8 rounded-lg" data-id="element-305" />
            <img src={PAYKIT_LOGO} alt="PayKit" className="h-6 hidden sm:block" data-id="element-306" />
          </Link>
          <div className="h-6 w-px bg-border hidden sm:block" data-id="element-307"></div>
          <span className="text-sm font-medium text-muted-foreground" data-id="element-308">
            Setup Wizard
          </span>
        </div>
        <Link to="/dashboard" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-2 transition-colors" data-id="element-309">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-310" />
          <span className="hidden sm:inline" data-id="element-311">Save & Exit</span>
        </Link>
      </header>

      <main className="flex-1 flex flex-col" data-id="element-312">
        <Outlet data-id="element-313" />
      </main>
    </div>;
}